export const auditNoteGuidance = {
  '2': "Include the unit's location, what you observed, and the dealer's explanation.",
  '3': "Include the unit's location, what you observed, and the dealer's explanation.",
  '4': 'Explain why the unit was not touched and what you observed.',
}

export const isAuditNoteRequired = (condition) => Object.hasOwn(auditNoteGuidance, String(condition))

export const isAuditNoteMissing = (notes) => !String(notes ?? '').trim()
